// extracted by mini-css-extract-plugin
export default {"create":"styles_create__VM8ws","row":"styles_row__J1PvK","col":"styles_col__tCQYp","flexRight":"styles_flexRight__zgWip"};